import React from "react"
import { generatePath } from "react-router-dom"
import Card from "./card"
import {
  hasSetDates,
  safeFormatDate,
} from "../../../../library/utils/dateConvert"
import { useAlert } from "../../../../hooks/useAlert"
import { KNOWMAP_INCOMING_KNOWMEET } from "../../../../library/constants/routes"

const UknowCard = ({
  uknow,
  openEditUknow,
  openDeleteUknow,
  openUknowInfo,
  canCopyLink = false,
}) => {
  const { successAlert } = useAlert()

  const link =
    document.location.origin +
    generatePath(KNOWMAP_INCOMING_KNOWMEET, {
      knowmeetId: uknow.id,
    })

  const copyLink = async () => {
    await navigator.clipboard.writeText(link)
    successAlert("Link copied to clipboard")
  }

  const dropdownMenuItems = [
    canCopyLink && {
      type: "button",
      action: copyLink,
      label: "Copy link",
    },
    {
      type: "button",
      action: openEditUknow,
      label: "Edit Meet",
    },
    {
      type: "h-divider",
      id: "hd1",
    },
    {
      type: "button",
      action: openDeleteUknow,
      label: "Delete Meet",
    },
  ].filter(Boolean)

  const infoComponent = () => (
    <>
      {hasSetDates([uknow.date_from, uknow.date_to]) && (
        // <p>
        //   Starts on: {safeFormatDate(uknow.date_from, { placeholder: '...' })} —{' '}
        //   {safeFormatDate(uknow.date_to, { placeholder: '...' })}
        // </p>
        <p>Starts on: {safeFormatDate(uknow.date_from, { withTime: true })}</p>
      )}
      {!!uknow.target_date && (
        <p>Target date: {safeFormatDate(uknow.target_date)}</p>
      )}

      <p>Cohort size: {uknow.cohort_size}</p>
    </>
  )

  return (
    <Card
      name={uknow.name}
      onNameClick={openUknowInfo}
      infoComponent={infoComponent}
      controls={{
        dropdownMenu: {
          items: dropdownMenuItems,
        },
      }}
    />
  )
}

export default UknowCard
